<form [formGroup]="moveToStepForm" (ngSubmit)="onSubmit()"> 
  <div class="move-to-step-form-group">
    <div class="form-group">
      <div class="row">
        <div class="col-3">
          <p-radioButton name="groupname" inputId="new" [value]="'new'" label="Create a new step"
            formControlName="stepType">
          </p-radioButton>
        </div>
        <div class="col-3">
          <p-radioButton name="groupname" inputId="existing" [value]="'existing'" label="Add to an existing step"
            formControlName="stepType"></p-radioButton>
        </div>
      </div>
    </div>
    <div class="form-group"
      *ngIf="moveToStepForm.get('stepType').value && moveToStepForm.get('stepType').value === 'new'">
      <div class="row">
        <div class="col-6">
          <label class="d-block required">Step Name</label>
          <input type="text" class="form-control" formControlName="newStepName" placeholder="Enter step name">
          <small *ngIf="!moveToStepForm.valid && moveToStepForm.get('newStepName').touched && moveToStepForm.errors"
            class="p-error">
            <span *ngIf="moveToStepForm.errors['newStepNameIsRequired']">Step Name is required.</span>
          </small>
        </div>
      </div>
    </div>
    <div class="form-group"
      *ngIf="moveToStepForm.get('stepType').value && moveToStepForm.get('stepType').value === 'existing'">
      <div class="row">
        <div class="col-6">
          <label class="d-block required">Select Step</label>
          <p-dropdown appendTo="body" class="w-100 move-to-step-dropdown" [options]="existingStepList"
            formControlName="existingStepName"
            [disabled]="!existingStepList || (existingStepList && existingStepList.length === 1)"
            [ngClass]="{'disabled': !existingStepList || (existingStepList && existingStepList.length === 1)}"
            optionLabel="stepName" optionValue="index"></p-dropdown>
          <small
            *ngIf="!moveToStepForm.valid && moveToStepForm.get('existingStepName').touched && moveToStepForm.errors"
            class="p-error">
            <span *ngIf="moveToStepForm.errors['existingStepNameIsRequired']">Step is required.</span>
          </small>
          <small *ngIf="!existingStepList || (existingStepList && existingStepList.length === 1)">
            No custom steps are available.
          </small>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <button type="submit" [disabled]="moveToStepForm.invalid" class="btn vdCreateBtn mr-3" >MOVE</button>
      <button type="button" class="btn vdCancelBtn mr-3" (click)="close()">CANCEL</button>
    </div>
  </div>
</form>
